import React from 'react'
import { ColumnsType } from 'antd/lib/table'
import { CalculateResultsType } from 'src/core/models'
import { CustomHeaderText, CalculateResultsMovileViewColumn } from 'src/components'


const calculateResultsColumns: ColumnsType<CalculateResultsType> = [
  {
    title: () => <CustomHeaderText text={'Cabify.Date'} />,
    dataIndex: 'date',
    sorter: (a, b) => a.date.localeCompare(b.date),
    sortDirections: ['descend', 'ascend'],
    responsive: ['md'],
    fixed: 'left'
  },
  {
    title: () => <CustomHeaderText text={'Cabify.ClientName'} />,
    dataIndex: 'client_name',
    sorter: (a, b) => a.client_name.localeCompare(b.client_name),
    sortDirections: ['descend', 'ascend'],
    responsive: ['md'],
    ellipsis: true,
    fixed: 'left'
  },
  {
    title: () => <CustomHeaderText text={'Cabify.KmDistance'} />,
    dataIndex: 'km_distance',
    sorter: (a, b) => a.km_distance - b.km_distance,
    sortDirections: ['descend', 'ascend'],
    responsive: ['md'],
  },
  {
    title: () => <CustomHeaderText text={'Cabify.Footprint'} />,
    dataIndex: 'footprint',
    sorter: (a, b) => a.footprint - b.footprint,
    sortDirections: ['descend', 'ascend'],
    responsive: ['md'],
  },
  {
    title: () => <CustomHeaderText text={'Cabify.Period'}/>,
    dataIndex: 'period',
    sorter: (a, b) => (a.period.length) - (b.period.length),
    sortDirections: ['descend', 'ascend'],
    responsive: ['md'],
  },
  {
    title: () => <CustomHeaderText text={'Cabify.Mean'}/>,
    dataIndex: 'mean',
    sorter: (a, b) => (a.mean || 0) - (b.mean || 0),
    sortDirections: ['descend', 'ascend'],
    responsive: ['md'],
  },
  {
    title: () => <CustomHeaderText text={'Cabify.Ratio'}/>,
    dataIndex: 'ratio',
    sorter: (a, b) => (a.ratio || 0) - (b.ratio || 0),
    sortDirections: ['descend', 'ascend'],
    responsive: ['md'],
  },
  {
    title: () => <CustomHeaderText text={'Diff'}/>,
    dataIndex: 'diff',
    sorter: (a, b) => (a.diff.length || 0) - (b.diff.length || 0),
    sortDirections: ['descend', 'ascend'],
    responsive: ['md'],
  },
  {
    title: () => <CustomHeaderText text={'Calculus results'} />,
    responsive: ['xs'],
    sorter: (a, b) => a.date.localeCompare(b.date),
    sortDirections: ['descend', 'ascend'],
    render: (_, calculus) => <CalculateResultsMovileViewColumn calculus={calculus} />
  },
]

export default calculateResultsColumns
